import React, { Component } from "react";
import { Input, Label } from "arv-reactcomponents";
import PropTypes from "prop-types";
import { PAYMENTPAGE } from "npmlinks-constants";
import Analytics from "../../../../analytics";
import Event from "../../../../analytics/eventFactory";


class CreditCardNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      binNumberLoading: false,
      cardId: "",
      cardIdErrorMsg: "",
      cardIdErrorClass: "",
      isValid: false,
      cardMinDigit: PAYMENTPAGE.CARD.MINCARDLENGTH,
      cardMaxDigit: PAYMENTPAGE.CARD.MAXCARDLENGTH,
      addedCardInfo: null,
    };
    this.handleCardIdChange = this.handleCardIdChange.bind(this);
    this.handleCardIdBlur = this.handleCardIdBlur.bind(this);
    this.triggerCardEnterGA = this.triggerCardEnterGA.bind(this);
  }

  triggerCardEnterGA(cardType) {
    try {
      const { cardData } = this.props;
      const { paymentTypeInfo, typeCode } = cardType;
      const cards = cardData[typeCode];
      const selectedCard = cards && cards.find(card => card.bankCode === paymentTypeInfo.bankCode) || [];
      Analytics.trackEvent({
        category: window.pageType,
        action: Event.action.PAYMENT_CARD_ENTERED(paymentTypeInfo.bankCode),
        label: selectedCard.requestedPG,
      });
    } catch (err) {
      console.log(err);
    }
  }

  get currentCardLogo() {
    const { addedCardInfo } = this.state;
    const cardType =
      addedCardInfo &&
      addedCardInfo.paymentTypeInfo &&
      addedCardInfo.paymentTypeInfo.bankCode;
    const isCardFound = addedCardInfo && addedCardInfo.isFound;
    return (isCardFound && cardType && cardType.replace("_", "-").toLowerCase()) || "";
  }
  /**
   * when credit card is being entered and suddenly we lost focus
   *  if form is already invalid so  do nothing ( means dont overwrite variables)
   * @param event
   */
  handleCardIdBlur(event) {
    event.preventDefault();
    const validateCardField = this.cardFieldRef.getValidatedOutput(
      event.target.value,
    );
    const { isValid, value, errorMsg } = validateCardField;
    const { cardMinDigit } = this.state;
    // handle cvv length also
    if (value && value.length < cardMinDigit) {
      this.setState({
        cardId: value,
        cardIdErrorMsg: `Minimum ${cardMinDigit} digits, please`,
        isValid: false,
        addedCardInfo: null,
      });
      this.props.handleSubmit({ isValid: false, cardId: value });
    } else {
      this.setState({
        cardId: value,
        cardIdErrorMsg: errorMsg,
        isValid,
      });
      this.props.handleSubmit({ isValid, cardId: value });
    }
  }

  /**
   * enter the credit card info and based on imput do validation
   * if form is invalid! set proper message , and based on pattern clear old data (discuss)
   * if form becomes valid , remove old error messages
   *
   * Based on card number length  we need to  get info about card and CVV length for this card
   * @param event
   */
  handleCardIdChange(event) {
    event.preventDefault();
    const validateCardField = this.cardFieldRef.getValidatedOutput(
      event.target.value,
    );
    const { isValid, value, errorMsg } = validateCardField;
    const { addedCardInfo, binNumberLoading } = this.state;
    if (!isValid) {
      // handle the setting of value empty
      if (!value) {
        this.setState({
          cardId: value,
          cardIdErrorMsg: errorMsg,
          isValid: false,
          addedCardInfo: null,
          binNumberLoading: false,
        });
        this.props.handleSubmit({ isValid: false, cardId: value });
      } else {
        this.setState({
          cardIdErrorMsg: errorMsg,
          isValid: false,
          addedCardInfo: null,
          binNumberLoading: false,
        });
        this.props.handleSubmit({ isValid: false, cardId: "" });
      }
      return;
    }

    if (
      this.state.addedCardInfo &&
      value &&
      value.length < PAYMENTPAGE.CARD_LENGTH_FORBIN
    ) {
      this.props.resetCardTypeInfo();
      this.setState({
        isValid,
        cardIdErrorMsg: null,
        cardId: value,
        addedCardInfo: null,
        binNumberLoading: false,
      });
      this.props.handleSubmit({ isValid, cardId: value });
    } else if (
      !addedCardInfo &&
      value &&
      value.length >= PAYMENTPAGE.CARD_LENGTH_FORBIN
    ) {
      this.setState({
        isValid,
        cardIdErrorMsg: null,
        cardId: value,
        addedCardInfo: null,
      });
      this.props.handleSubmit({ isValid, cardId: value });
      // TODO:: need to check with native promise functions
      if (!binNumberLoading) {
        this.setState({
          binNumberLoading: true,
        });
        this.props
          .getCardTypeInfo(value.substring(0, PAYMENTPAGE.CARD_LENGTH_FORBIN))
          .then(
            binInfoData => {
              const { cardInfo } = binInfoData;
              if(!cardInfo.isFound) {
                this.props.handleSubmit({
                    isValid: false,
                    errorMessageToast: PAYMENTPAGE.ERRORS.INVALID_BIN_NUMBER,
                });
              }
              this.setState({
                isValid,
                cardIdErrorMsg: null,
                addedCardInfo: cardInfo,
                binNumberLoading: false,
              });
              this.triggerCardEnterGA(cardInfo);
            },
            () => {
              this.setState({
                isValid: false,
                cardIdErrorMsg: null,
                addedCardInfo: null,
                binNumberLoading: false,
              });
              this.props.handleSubmit({
                isValid: false,
                errorMessageToast: PAYMENTPAGE.ERRORS.WRONG_BIN_NUMBER,
              });
            },
          );
      }
    } else {
      this.setState({
        isValid,
        cardIdErrorMsg: null,
        cardId: value,
        binNumberLoading: false,
      });
    }
    this.props.handleSubmit({ isValid, cardId: value });
  }

  render() {
    const { isValid, cardIdErrorMsg, cardIdErrorClass } = this.state;
    return (
      <div className="nw-creditcard-number">
        <Label
          htmlFor="nw-paymentoption-creditcard"
          className="nw-paymentoption-creditcard"
        >
          <Label className="nw-creditcardnumber-line1">
            {PAYMENTPAGE.CARDTEXT.CARDTITLE} {PAYMENTPAGE.CARDTEXT.CARDSUBTITLE}
          </Label>
        </Label>
        <Input
          className={`nw-creditcardnumber-input nw-creditcard-input ${isValid} ${cardIdErrorClass} ${
            this.currentCardLogo
            }`}
          type="tel"
          name="cardId"
          id="nw-paymentoption-creditcard"
          value={this.state.cardId}
          ref={values => {
            this.cardFieldRef = values;
          }}
          validateWithPattern={[
            {
              pattern: /^(?!0)\d+$/,
              msg: PAYMENTPAGE.CARD_VALIDATION_MESSAGES.CARDNUMBER_PATTERN,
            },
          ]}
          onChange={this.handleCardIdChange}
          maxlength={`${this.state.cardMaxDigit}`}
          onBlur={this.handleCardIdBlur}
        />
        <div className="nw-paymentwallet-error" id="creditcarderror">
          {cardIdErrorMsg}
        </div>
      </div>
    );
  }
}

CreditCardNumber.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  getCardTypeInfo: PropTypes.func.isRequired,
  resetCardTypeInfo: PropTypes.func.isRequired,
  cardData: PropTypes.shape({}).isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: CreditCardNumber,
  component: CreditCardNumber,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentWallet/CreditCard/CreditCardNumber/index.js